import { Crm1Dashboard } from "@/components/crm-demos/crm-1-dashboard"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-1")({
  component: Crm1Page,
  head: () => ({ meta: [{ title: "CRM 1 · Sales Dashboard" }] }),
});

function Crm1Page() {
  return <Crm1Dashboard />
}
